import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { content } from "./content";
import ArticleCard from "./articlecard";
import SEOHelmet from "./SEOHelmet";

export default function Articles() {
    return (
      <>
        <SEOHelmet 
          title="Articles & Thoughts - Rick Molenaar"
          description="Read my thoughts on software engineering leadership, tech organization design, agile transformation, and technology management."
          canonicalUrl="https://rickmolenaar.me/articles"
        />
        <Container fluid className="bg-theme-primary">
          <Row className="mt-1 ms-1">
            {content.articles.map((article, index) => (
              <Col sm={6} lg={3} className="mb-5" key={"article_" + index} data-testid="article-col">
                <ArticleCard data={article} />
              </Col>
            ))}
          </Row>
        </Container>
      </>
    );
  }
  